export default __webpack_public_path__ + "static/media/p2-6.a09e63b8.png";